module.exports = __webpack_public_path__ + "img/home_talk.8096124d.png";